import type {
  ConfirmAppointmentRow,
  ConfirmAppointmentsInit,
} from "../confirm-appointments-contract"

export const buildConfirmAppointmentRows = (
  init: ConfirmAppointmentsInit,
): ConfirmAppointmentRow[] => {
  const workOrderById = new Map(init.workOrders.map((workOrder) => [workOrder.id, workOrder]))
  const sourceRowByWorkOrderId = new Map((init.sourceRows ?? []).map((row) => [row.id, row]))
  const propertyById = new Map((init.properties ?? []).map((property) => [property.id, property]))

  return init.events
    .filter((event) => event?.id)
    .map((event) => {
      const workOrder = event.work_order_id
        ? (workOrderById.get(event.work_order_id) ?? null)
        : null
      const workOrderRow = event.work_order_id
        ? (sourceRowByWorkOrderId.get(event.work_order_id) ?? null)
        : null

      return {
        id: event.id,
        event,
        workOrder,
        workOrderRow,
        property: event.property_id ? (propertyById.get(event.property_id) ?? null) : null,
      }
    })
}

export const confirmableMailEventIds = (
  output:
    | { items: Array<{ event_id: string; status: string; event?: ScheduleEvent | null }> }
    | null
    | undefined,
) =>
  (output?.items ?? [])
    .filter((item) => item.event?.id && ["confirmed", "already_confirmed"].includes(item.status))
    .map((item) => item.event?.id as string)
